/* istanbul ignore file */
import React from 'react';
import { EditButton, EditButtonProps } from 'framework/ui/ui-builder';
import { UPDATE_EMPLOYEE_CONTRACT } from 'domain/people/employee/contracts/shared/employeeContractsService';
import { useEmployeeContractUrl } from 'domain/people/employee/contracts/employeeContractRouting';

const EditEmployeeContractButton = (props: EditButtonProps) => {
  const { getUpdateEntityUrl } = useEmployeeContractUrl();

  return (
    <EditButton {...props} size="small" outline permissionToCheck={UPDATE_EMPLOYEE_CONTRACT} path={getUpdateEntityUrl}>
      Edit
    </EditButton>
  );
};

export default EditEmployeeContractButton;
